export default function(){
    window.localError = function(errorObj, size='') {
		const modal = $('#global_error_modal');
		modal.find('.modal-dialog').removeClass('modal-lg');
		modal.find('.modal-body').removeClass('medium');
		if(size == 'large'){
			modal.find('.modal-dialog').addClass('modal-lg');
			modal.find('.modal-body').addClass('medium');
		}
		let message = '';
		try {
			if(typeof(errorObj) == 'string') {
				message = errorObj;
			}
			else {
				message = errorObj.message;
			}
		}
		catch(e){

		}
		console.log(errorObj);
		modal.find('.modal-body').html(message);
		modal.modal('show');
		
	}
	window.showProcessingOverlay = function(){
		$('#overlaydiv')            
		.removeClass('d-none')
		.addClass('d-flex');		
	}

	window.getUrlParameter = function(variable){
		const query = window.location.search.substring(1);
		const vars = query.split("&");
		for (let i=0;i<vars.length;i++) {
		  let pair = vars[i].split("=");
		  if(pair[0] == variable){
			return pair[1];
		  }
		}
		return(false);
	}
    
	window.hideProcessingOverlay = function(){  
		$('#overlaydiv').addClass('d-none').removeClass('d-flex');
	}
	window.scrollToElement = function(selector, buffer=false){
		const trueSelector = typeof(selector) == 'object' ? selector : $(selector);
		if(trueSelector.offset()){
			let theOffset = trueSelector.offset().top;
			if(buffer == true){
			  theOffset = theOffset - 20;
			}
			window.scroll({top: theOffset, behavior: 'smooth'});
		}
		
    }
    $(document).ready(function(){
        $('.confirmAndGo').on('click',function(ev){
            if(confirm($(this).data('confirm'))){
                document.location = $(this).data('url');
            }
            else {
                ev.preventDefault();
            }
        });
    });
  
}